<template>
  <!-- 在线咨询 -->
  <div id="lawyerOnline">

    <section><laonlbaner /></section>

    <section><laonlttlay /></section>

    <section><laonlsec /></section>

    <section><laonlzxls /></section>
    <!-- 中间banner横幅 -->
    <!-- <section class="laocen_bg">
      <img src="../../assets/lawyerOnline/laonlcenter_bg.png" alt="" />
    </section> -->

	<section><laonlhfrmzx /></section>

    <section><laonlkbls /></section>


    <section style="background: #f8f8f8;"><findlawyerjxflzs /></section>

    <section><findlawyerflsphb /></section>
	
	<section style="background-color: #f8f8f8;">
		<ul class="bottombar between">
			<li class="flex flex_start">
				<img src="../../assets/lawyerOnline/fu.png" >
				<div class="flex-col">
					<span class="FontSize18">覆盖全球</span>
					<span class="FontSize14 FontGray">覆盖中国及国际的律师</span>
				</div>
			</li>
			<li class="flex flex_start">
				<img src="../../assets/lawyerOnline/24.png" >
				<div class="flex-col">
					<span class="FontSize18">24小时在线</span>
					<span class="FontSize14 FontGray">律师7*24小时在线服务</span>
				</div>
			</li>
			<li class="flex flex_start">
				<img src="../../assets/lawyerOnline/shi.png" >
				<div class="flex-col">
					<span class="FontSize18">实时服务</span>
					<span class="FontSize14 FontGray">律师秒级接单，快速响应</span>
				</div>
			</li>
			<li class="flex flex_start">
				<img src="../../assets/lawyerOnline/zhuan.png" >
				<div class="flex-col">
					<span class="FontSize18">专业认真</span>
					<span class="FontSize14 FontGray">专业高效，尽职尽责</span>
				</div>
			</li>
		</ul>
	</section>
  </div>
</template>

<script>

import laonlbaner from "./child/laonlbaner"; //在线律师的banner头部
import laonlttlay from "./child/laonlttlay"; //特推律师
import laonlsec from "./child/laonlsec"; //特推律师下面咋项
import laonlzxls from "./child/laonlzxls"; //在线律师
import laonlkbls from "./child/laonlkbls"; //在线律师
import laonlhfrmzx from "./child/laonlhfrmzx"; //合肥热门咨询
import findlawyerjxflzs from "views/findLawyers/child/jxflzs"; //精选法律知识
import findlawyerflsphb from "views/findLawyers/child/qesthflsphb"; //合肥律师排行榜

export default {
  name: "lawyerOnline",

  components: {

    laonlbaner,
    laonlttlay,
    laonlsec,
    laonlzxls,
    laonlkbls,
    laonlhfrmzx,
    findlawyerjxflzs,
    findlawyerflsphb,
  },
};
</script>

<style lang="scss" scope>
#lawyerOnline {
  // background-color: #fff;
  // .laocen_bg {
  //   max-width: 1920px;
  //   width: 100%;
  //   overflow: hidden;
  //   margin: 0 auto;
  //   img {
  //     width: 1920px;
  //   }
  // }
  .bottombar{
	  width: 1200px;
	  margin:  auto;
	  padding: 35px 0;
	  li{
		  width: 25%;
		  img{
			  margin-right: 20px;
		  }
	  }
  }
}
</style>